export default __webpack_public_path__ + "static/report-banner-25111eca18af7d610def72aeff16dfb7.png";